<template lang="pug">
.equipment-tab
  .product-summary(v-for="product in gym.products")
    .product-thumb
      StaticImage(:src="product.thumbnail" :width="84" :alt="product.name")
    .product-info
      .product-name {{ product.name }}
      RogueButton.product-details-btn(@click="$emit('featureProduct', product)" color="link-black") {{ __('See Details') }}
</template>

<script setup lang="ts">
import type { IGym, IGymProduct } from '@rogue/universal'

defineProps<{
  gym: IGym
}>()

defineEmits<{(e: 'featureProduct', product: IGymProduct): void }>()

</script>

<style lang="scss" scoped>
.equipment-tab {
  display: flex;
  flex-direction: column;
  gap: $space-s;
  padding: $space-s;

  .product-summary {
    display: flex;
    flex-direction: row;
    gap: $space-xs;
  }

  .product-thumb {
    width: 84px;
  }

  .product-info {
    display: flex;
    flex-direction: column;
    gap: $space-xxxs;
  }

  .product-name {
    font-weight: bold;
    font-size: $size-xs;
    line-height: $size-m;
  }

  .product-details-btn {
    color: $color-black-light;
    font-size: $size-xxs;
    padding: 0;
    text-decoration: underline;
    width: fit-content;
  }
}
</style>
